/* global axios */
import ApiClient from './ApiClient';

export const buildDealParams = (page, sort, stage, search, companyId) => {
  let params = `page=${page}`;
  if (sort) {
    params = `${params}&sort=${sort}`;
  }
  if (stage) {
    params = `${params}&stage=${stage}`;
  }
  if (search) {
    params = `${params}&q=${encodeURIComponent(search)}`;
  }
  if (companyId) {
    params = `${params}&company_id=${companyId}`;
  }
  return params;
};

class DealAPI extends ApiClient {
  constructor() {
    super('deals', { accountScoped: true });
  }

  get(params = {}) {
    const {
      page = 1,
      sort = '',
      stage = '',
      search = '',
      companyId = '',
    } = params;
    const requestURL = `${this.url}?${buildDealParams(
      page,
      sort,
      stage,
      search,
      companyId
    )}`;
    return axios.get(requestURL);
  }

  search({ q = '', limit = 5 }) {
    return axios.get(
      `${this.url}/search?q=${encodeURIComponent(q)}&limit=${limit}`
    );
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(dealData) {
    return axios.post(this.url, { deal: dealData });
  }

  update(id, dealData) {
    return axios.patch(`${this.url}/${id}`, { deal: dealData });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  pipelineSummary() {
    return axios.get(`${this.url}/pipeline_summary`);
  }
}

export default new DealAPI();
